import PercentageValue from "@/components/tableElements/PercentageValue";
import { CurrencyValue } from "@/components/tableElements";
import AppPopover from "@/components/AppPopover";
import TargetIcon from "@/components/icons/TargetIcon.vue";
export default {
  name: "PpcBAProductMarginCell",
  components: {
    PercentageValue,
    CurrencyValue,
    AppPopover,
    TargetIcon
  },
  props: {
    acos4W: {
      type: Number
    },
    mode: {
      type: String
    },
    roas4W: {
      type: Number
    },
    item_id: {
      type: String
    },
    cap: {
      type: Number
    }
  }
};